import styled, { keyframes } from "styled-components";
import Image from "../image";

const rotateX = keyframes`
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
`;

export const BoxLoadingPage = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #000;
    opacity: 0.8;
  }
`;

export const ImageComponent = styled(Image)`
  position: relative;
  width: 100px;
  height: 100px;
  animation: ${rotateX} 1.5s infinite linear;
  transform-style: preserve-3d;
`;
